export interface ContextField {
  key: string;
  value: string;
}

export const AssistantBrainEditor = (initialFields: ContextField[] = []) => ({
  fields: initialFields,

  init() {
    // Initial setup if needed
  },

  addField() {
    this.fields.push({ key: "", value: "" });
  },

  removeField(index: number) {
    this.fields.splice(index, 1);
  },

  autoExpand(el: HTMLElement) {
    el.style.height = "auto";
    el.style.height = el.scrollHeight + "px";
  },
});
